import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { loadPlaybooks } from './store/playbooks/actions';

import DealTypes from './deal_types';
import LoadingSpinner from 'components/loading_spinner';

import Playbook from './playbook';

import './styles.scss';

export function ConnectedPlaybooksConfig({ dealType, loadPlaybooks, playbooks, stage }) {
  useEffect(() => {
    loadPlaybooks();
  }, []);

  if (!playbooks) {
    return <LoadingSpinner/>;
  }

  return (
    <div className="playbooks-config">
      <DealTypes/>
      <Playbook
        playbook={playbooks.find(playbook => playbook.dealType === dealType)}
        playbooks={playbooks}
        stage={stage}
      />
    </div>
  );
}

ConnectedPlaybooksConfig.propTypes = {
  dealType: PropTypes.string.isRequired,
  loadPlaybooks: PropTypes.func.isRequired,
  playbooks: PropTypes.array,
  stage: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  dealType: state.dealType,
  playbooks: state.playbooks,
  stage: state.stage,
});

const mapDispatchToProps = {
  loadPlaybooks,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedPlaybooksConfig);
